function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 22"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 32",
  d: "M4.942 5.497L1.697 1.289h-1.7v9.528h1.864V4.554l3.014 3.731h.1l3.041-3.758v6.291H9.88V1.29h-1.7z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 33",
  d: "M36.69 10.814h1.828V.731l-1.832.55z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 34",
  d: "M33.384 10.814h1.832V.731l-1.832.55z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 35",
  d: "M22.772 3.735l-.133-.035a4.619 4.619 0 00-1.129-.14 3.362 3.362 0 00-2.219.743 3.936 3.936 0 00-1.12 3.11 3.532 3.532 0 001.053 2.831 3.578 3.578 0 002.381.735 8.609 8.609 0 002.93-.577l.047-.018V.79l-1.81.493zm0 5.522l-.073.024a3.078 3.078 0 01-.842.138h-.061a1.654 1.654 0 01-1.024-.289 2.169 2.169 0 01-.66-1.82c0-1.354.648-2.162 1.733-2.162a2.524 2.524 0 01.858.16l.069.025z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M40.07 10.816h1.832V3.375l-1.832.557z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37",
  d: "M39.755 1.293l1.314 1.334 1.314-1.314-1.314-1.314z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38",
  d: "M28.59 3.446a5.152 5.152 0 00-2.292.524v1.5h.014a5.172 5.172 0 012.194-.479 1.635 1.635 0 011.241.385 1.706 1.706 0 01.243 1.105 5.594 5.594 0 00-1.233-.144c-2.089 0-3.239.906-3.239 2.331a2.365 2.365 0 002.531 2.3 3.583 3.583 0 002.08-.579v.4h1.757V6.274c-.001-2.535-1.882-2.828-3.296-2.828zm1.42 5.587a1.961 1.961 0 01-1.548.59.963.963 0 01-1.092-.975c0-.792.794-1.075 1.537-1.075a5.214 5.214 0 011.1.1z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 39",
  d: "M45.958 3.446a5.152 5.152 0 00-2.292.524v1.5h.014a5.173 5.173 0 012.194-.479 1.636 1.636 0 011.241.385 1.708 1.708 0 01.243 1.105 5.594 5.594 0 00-1.233-.144c-2.089 0-3.239.906-3.239 2.331a2.365 2.365 0 002.531 2.3 3.583 3.583 0 002.08-.579v.4h1.757V6.274c-.001-2.535-1.882-2.828-3.296-2.828zm1.419 5.587a1.961 1.961 0 01-1.547.59.963.963 0 01-1.092-.975c0-.792.794-1.075 1.537-1.075a5.214 5.214 0 011.1.1z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 40",
  d: "M17.403 7.107a3.772 3.772 0 00-.947-2.857 3.065 3.065 0 00-2.154-.8 3.477 3.477 0 00-2.253.8 3.768 3.768 0 00-1.164 3c0 3.384 2.529 3.749 3.616 3.749a6.278 6.278 0 002.43-.559V8.912a4.257 4.257 0 01-2.132.576 2.142 2.142 0 01-1.809-.908 1.883 1.883 0 01-.275-.707h4.662s.026-.451.026-.766zm-4.673-.539a1.738 1.738 0 01.177-.787 1.539 1.539 0 011.392-.807 1.4 1.4 0 011.328.814 1.89 1.89 0 01.143.781z",
  fill: "#fff"
});

function SvgDarkModePoweredBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.253 11"
  }, props), _ref, _ref2, _ref3);
}

export default SvgDarkModePoweredBy;